import styled from 'styled-components';
import Screen from '@/styles/Themes/Screen';
import { colors } from '@/styles/Themes/LightTheme/Colors';
import { cssVars } from '@/styles/Themes/cssVars';
import Palette from '@/styles/Themes/Palette';
import { radius, borders } from '@/styles/Themes/Metrics';
import Text from '@/styles/Themes/Text';
import { Transition } from '@/styles/Themes/KeyFrames';

export const ParagraphWrapper = styled.div`
    margin: 0 0 10px;

    ${Screen.desktop} {
        margin: 60px 0 50px;
    }
`;

export const CommonTitle = styled.h1`
    color: ${cssVars.fg_gray2_white};
    margin: 20px 0 0 0;
    color: ${cssVars.fg_gray1_white};
    ${Text.Mobile.heading2};

    ${Screen.ipad} {
        ${Text.Ipad.heading3};
    }

    ${Screen.desktop} {
        ${Text.Desktop.heading2};
    }
`;

export const CommonWrapper = styled.div`
    display: flex;
    width: 100%;
    align-items: flex-start;
    justify-content: center;
`;

export const ListContainer = styled.div`
    padding: 10px 0;
    background-color: ${cssVars.bg_white_blue};
    width: 100%;

    ${Screen.desktop} {
        width: 320px;
        background: ${cssVars.bg_ash_blueDark};
        border-radius: ${radius.small};
        padding: 25px 10px;
        margin-right: 24px;
        overflow-y: hidden;
    }
`;

export const ScrollListContainer = styled.div`
    overflow: auto;

    ${Screen.desktop} {
        padding: 0 15px;
        max-height: 1048px;
        overflow-y: scroll;
        overflow-x: hidden;

        ::-webkit-scrollbar {
            width: 6px;
        }
        ::-webkit-scrollbar-track {
            background-color: ${cssVars.bg_ash_blueDark};
            border-radius: 10px;
        }
        ::-webkit-scrollbar-thumb {
            height: 30px;
            background: ${cssVars.bg_gray4_dark2};
            border-radius: 10px;
        }
    }
`;

export const DesktopResultWrapper = styled.div`
    display: none;
    ${Screen.desktop} {
        display: block;
        flex: 1;
    }
`;

export const MenuSelect = styled.div<{ isOpen: boolean; isInfinityList: boolean }>`
    font-size: ${Text.Full.medium.medium};
    color: ${(props) => (props.isOpen ? `${colors.primary}` : `${cssVars.svg_gray1_gray3}`)};
    max-height: ${({ isOpen, isInfinityList }) =>
        isOpen ? (isInfinityList && 'auto') || '650px' : '55px'};
    border-radius: ${radius.small};
    padding: ${(props) => (props.isOpen ? `0 20px 15px` : `0 20px`)};
    align-items: center;
    box-shadow: ${(props) => (props.isOpen ? cssVars.shadow_card_default : 'none')};
    background: ${(props) => (props.isOpen ? cssVars.bg_white_dark3 : 'none')};
    &:active {
        border-radius: ${radius.small};
        background: ${cssVars.bg_white_dark3};
        color: ${colors.primary};
    }

    ${Screen.ipad} {
        max-height: ${({ isOpen, isInfinityList }) =>
            isOpen ? (isInfinityList && 'auto') || '944px' : '65px'};
        padding: ${(props) => (props.isOpen ? `0 30px 30px` : `0 30px`)};
    }
    ${Screen.desktop} {
        height: 45px;
    }

    &:hover {
        color: ${colors.primary};
        cursor: pointer;
    }
`;

export const MenuHeader = styled.div<{ isOpen: boolean }>`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    height: 55px;
    border-bottom: ${(props) =>
        props.isOpen ? 'none' : `${borders.small} ${cssVars.bg_ash_dark2}`};

    ${Screen.desktop} {
        height: 45px;
        border-bottom: none;
    }
`;

export const CommonDropdown = styled.div<{ isOpen: boolean }>`
    transform: ${(props) =>
        props.isOpen ? 'rotate(-180deg) translate(0, 0)' : 'rotate(0deg) translate(0, 0)'};
    ${Transition.arrow};
    height: 20px;
    ${Screen.desktop} {
        display: none;
    }
`;

export const DestinationName = styled.div`
    width: 70%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const CodeTitle = styled.div`
    margin: 0 1em 0 auto;
`;

export const ItemContainer = styled.div<{ isOpen?: boolean }>`
    display: flex;
    flex-wrap: wrap;
    gap: 20px;
    justify-content: center;

    > button {
        margin: 1em auto;
        &:hover {
            background-color: ${Palette.gradient.dark};
        }
    }
    max-height: ${({ isOpen }) => (isOpen ? 'none' : '0')};

    ${Screen.ipad} {
        gap: 30px;
    }
    ${Screen.desktop} {
        max-height: none;
    }
`;

export const MobileItemsContainer = styled.div<{ isOpen?: boolean }>`
    display: grid;
    grid-gap: 20px;

    > button {
        margin: 1em auto;
        &:hover {
            background-color: ${Palette.gradient.dark};
        }
    }
    max-height: ${({ isOpen }) => (isOpen ? 'none' : '0')};

    ${Screen.ipad} {
        grid-gap: 30px;
    }
    ${Screen.desktop} {
        display: none;
    }
`;

export const BtnWrapper = styled.div`
    ${Screen.desktop} {
        display: none;
    }
`;

export const ViewMoreWrapper = styled.div`
    margin-top: 32px;

    ${Screen.desktop} {
        margin-top: 24px;
    }
`;

export const DesktopResultContainer = styled.div`
    ${Screen.desktop} {
        display: flex;
        flex-wrap: wrap;
        position: relative;
        gap: 24px;
        width: 100%;
    }
`;

export const Blur = styled.div`
    display: none;

    ${Screen.desktop} {
        display: block;
        position: sticky;
        bottom: 15px;
        width: 100%;
        height: 73px;
        background: ${cssVars.blur_gradient};
    }
`;

export const InView = styled.div`
    height: 3px;
    width: 3px;
    position: absolute;
    top: 67em;
`;

export const WrapperSubscribe = styled.div`
    padding: 15px 0 25px;

    ${Screen.ipad} {
        padding: 20px 0 30px;
    }

    ${Screen.desktop} {
        padding: 20px 0 60px;
    }
`;
